/**
 * The vendor ops dashboard (container, D27): `GET /vendor/ops`, live through
 * the vendor mirror of every tenant's changes and re-read every 30 s.
 */
import { useNow, useVendorOps } from '../app/hooks.js';
import { OpsDashboard } from '../components/vendor/OpsDashboard.js';

function messageOf(err: unknown): string {
  return err instanceof Error ? err.message : String(err);
}

export function VendorOpsView() {
  const ops = useVendorOps();
  const now = useNow(10_000);
  return <OpsDashboard ops={ops.data ?? null} loading={ops.isFetching} error={ops.error === null ? null : messageOf(ops.error)} nowMs={now} onRetry={() => void ops.refetch()} />;
}
